var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2 drawer-header d-flex"},[_c('div',{staticClass:"icon-wrapper",class:_vm.iconClass},[_c('img',{attrs:{"src":_vm.icon}})]),_c('div',{staticClass:"info mx-2"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.content.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }